import { get } from 'lib/sequence/component/state/value'
import filterRef from './ref'

/**
 * Sets the team filter according to the selected value.
 *
 * @param {Gaia.AppModule.Spec} module the ticket module composition object
 * @returns {function(*, {filter?: {}}=, ...[*]): Promise<[undefined,{filter: {}},...*[]]>}
 */
export default module => async (children, { filter = {} } = {}, ...args) => {
  const { team } = children

  const accumulatedFilter = filter
  const selectedTeam = get(team)
  accumulatedFilter.team = filterRef(module, selectedTeam)

  return [children, { filter: accumulatedFilter }, ...args]
}
